import classes from "./Item.module.scss";
import Cards from "../../../Cards/Cards";
import Image from "../../../Image/Image";


const Item = props => {
  return (
    <div className={classes.Item + " " + props.customWrapClass}>
      <Cards
        number={props.number}
        title={props.title}
        text={props.text}

        customClass={props.customClass}
        customTitleClass={props.customTitleClass}
        customClassText={props.customClassText}
      />
      {props.src
         ? <div className={classes.Image + " " + (props.customImgWrap || "")}>
        <Image src={props.src} srcWebp={props.srcWebp} />
      </div>
      : ""
      }
    </div>
  )
}

export default Item;